(function(){
  var root = document.querySelector('[data-pdp-acc]');
  if(!root) return;

  var items = Array.prototype.slice.call(
    root.querySelectorAll('details.pdp-acc__item')
  );

  var DURATION = 320;

  function panelOf(d){ return d.querySelector('.pdp-acc__panel'); }

  function afterHeight(d, p, done){
    var token = {};
    d._accToken = token;
    var finished = false;
    function finish(){
      if(finished || d._accToken !== token) return;
      finished = true;
      p.removeEventListener('transitionend', onEnd);
      done();
    }
    function onEnd(e){
      if(e.target === p && e.propertyName === 'height') finish();
    }
    p.addEventListener('transitionend', onEnd);
    setTimeout(finish, DURATION + 60);
  }

  function openWithAnim(d){
    var p = panelOf(d);
    if(!p) return;

    items.forEach(function(other){
      if(other !== d && other.classList.contains('is-open')) closeWithAnim(other);
    });

    var start = d.open ? p.getBoundingClientRect().height : 0;
    d.open = true;
    d.classList.add('is-open');
    p.style.height = start + 'px';
    p.offsetHeight;
    p.style.height = p.scrollHeight + 'px';

    afterHeight(d, p, function(){
      p.style.height = 'auto';
    });
  }

  function closeWithAnim(d){
    var p = panelOf(d);
    d.classList.remove('is-open');
    if(!p){ d.open = false; return; }

    p.style.height = p.getBoundingClientRect().height + 'px';
    p.offsetHeight;
    p.style.height = '0px';

    afterHeight(d, p, function(){
      d.open = false;
    });
  }

  items.forEach(function(d){
    var p = panelOf(d);
    if(!p) return;

    if(d.open){
      d.classList.add('is-open');
      p.style.height = 'auto';
    } else {
      p.style.height = '0px';
    }

    var sum = d.querySelector('summary');
    if(!sum) return;

    sum.addEventListener('click', function(e){
      e.preventDefault();
      if(d.classList.contains('is-open')) closeWithAnim(d);
      else openWithAnim(d);
    });
  });
})();